import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import DeleteCouponModal from "./modals/DeleteCouponModal";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function OneCoupon({ selectedCouponId, changeView }) {
  const [isLoading, setIsLoading] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false);
  const [couponData, setCouponData] = useState(null);

  const cancelModal = () => {
    setDeleteModal(false);
    changeView("MainPage");
  };

  const { user } = useAuthContext();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${ApiConnectionString}/api/Coupon/${selectedCouponId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setCouponData(response.data);
    } catch (error) {
      console.error("Failed to fetch coupon:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading) return <div><LoadingSpinner /></div>;

return (
  <div className="container py-4">
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h2 className="mb-0">Coupon Details</h2>
      <div>
        <button className="btn btn-secondary me-2" onClick={() => changeView("MainPage")}>
          Go back
        </button>
        <button className="btn btn-danger" onClick={() => setDeleteModal(true)}>
          Delete
        </button>
      </div>
    </div>

    {couponData && (
      <div className="mb-5">
        <div className="card mb-4 shadow-sm">
          <div className="card-body">
            <h5 className="card-title">Coupon Info</h5>
            <p className="mb-2"><strong>Name:</strong> {couponData.coupon.name}</p>
            <p className="mb-2"><strong>Percent Off:</strong> {couponData.coupon.percentOff}%</p>
            <p className="mb-2"><strong>Duration:</strong> {couponData.coupon.duration}</p>
            <p className="mb-2"><strong>Valid:</strong> {couponData.coupon.valid ? "Yes" : "No"}</p>
            <p className="mb-0"><strong>Promotion Code:</strong> {couponData.coupon.promotionCode}</p>
          </div>
        </div>

        {couponData.appliesTo && couponData.appliesTo.length > 0 && (
          <>
            <h4 className="mb-3">Applies To</h4>
            <div className="row">
              {couponData.appliesTo.some(item => item.type === "flex") && (
                <div className="col-md-4 mb-4">
                  <h5>Flex</h5>
                  {couponData.appliesTo
                    .filter(item => item.type === "flex")
                    .map(item => (
                      <div key={item.id} className="card mb-3 shadow-sm">
                        <div className="card-body">
                          <p className="mb-1"><strong>Name:</strong> {item.name}</p>
                          <p className="mb-1"><strong>Price:</strong> £{item.price / 100}</p>
                          <p className="mb-0"><strong>Token:</strong> {item.token}</p>
                        </div>
                      </div>
                    ))}
                </div>
              )}

              {couponData.appliesTo.some(item => item.type === "sub") && (
                <div className="col-md-4 mb-4">
                  <h5>Subscription</h5>
                  {couponData.appliesTo
                    .filter(item => item.type === "sub")
                    .map(item => (
                      <div key={item.id} className="card mb-3 shadow-sm">
                        <div className="card-body">
                          <p className="mb-1"><strong>Name:</strong> {item.name}</p>
                          <p className="mb-0"><strong>Price:</strong> £{item.price / 100}</p>
                        </div>
                      </div>
                    ))}
                </div>
              )}

              {couponData.appliesTo.some(item => item.type === "event") && (
                <div className="col-md-4 mb-4">
                  <h5>Classes</h5>
                  {couponData.appliesTo
                    .filter(item => item.type === "event")
                    .map(item => (
                      <div key={item.id} className="card mb-3 shadow-sm">
                        <div className="card-body">
                          <p className="mb-1"><strong>Name:</strong> {item.name}</p>
                          <p className="mb-1"><strong>Day:</strong> {item.day}</p>
                          <p className="mb-1"><strong>Time:</strong> {item.timeIn} - {item.timeOut}</p>
                          <p className="mb-0"><strong>Price:</strong> £{item.price / 100}</p>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    )}

    {deleteModal && (
      <DeleteCouponModal
        selectedCouponId={selectedCouponId}
        cancelModal={cancelModal}
      />
    )}
  </div>
);}
